<template>
  <div class="developer">
    <TopNav :curTabProps="'4'" />
    <el-row type="flex" justify="start" class="choose-date">
      <YearRangePicker @yearChange="handleYearChange"/>
    </el-row>

    <el-row :gutter="20" class="summary-row">
      <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8" class="chart-col">
        <year-bar-chart
          :years="yearList"
          :statistics="newHostedApps"
          title="新增托管应用"
          height="400px"
        />
      </el-col>
      <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8" class="chart-col">
        <year-bar-chart
          :years="yearList"
          :statistics="newAuthCodes"
          title="新增授权码"
          height="400px"
        />
      </el-col>
      <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8" class="chart-col">
        <year-bar-chart
          :years="yearList"
          :statistics="newUsers"
          title="新增用户"
          height="400px"
        />
      </el-col>
    </el-row>

    <el-row :gutter="20" class="summary-row">
      <el-col :xs="24" :sm="24" :md="6" :lg="6" :xl="6" class="chart-col">
        <year-bar-chart
          :years="yearList"
          :statistics="appliUseYearDataList"
          title="托管应用使用（分钟）"
          height="400px"
        />
      </el-col>
      <el-col :xs="24" :sm="24" :md="6" :lg="6" :xl="6" class="chart-col">
        <year-bar-chart
          :years="yearList"
          :statistics="snUseYearDataList"
          title="授权码使用（分钟）"
          height="400px"
        />
      </el-col>
      <el-col :xs="24" :sm="24" :md="6" :lg="6" :xl="6" class="chart-col">
        <year-bar-chart
          :years="yearList"
          :statistics="weixinAmountDataList"
          title="微信充值金（元）"
          height="400px"
        />
      </el-col>
      <el-col :xs="24" :sm="24" :md="6" :lg="6" :xl="6" class="chart-col">
        <year-bar-chart
          :years="yearList"
          :statistics="backAmountDataList"
          title="后台充值金（元）"
          height="400px"
        />
      </el-col>
    </el-row>

    <el-row :gutter="20" class="summary-row">
      <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8" class="chart-col">
        <year-bar-chart
          :years="appliUseTop10x"
          :statistics="appliUseTop10y"
          title="托管应用使用排名（分钟）"
          height="400px"
        />
      </el-col>
      <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8" class="chart-col">
        <year-bar-chart
          :years="snUseTop10x"
          :statistics="snUseTop10y"
          title="授权码使用排名（分钟）"
          height="400px"
        />
      </el-col>
      <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8" class="chart-col">
        <year-bar-chart
          :years="natUseTop10x"
          :statistics="natUseTop10y"
          title="NAT使用排名（分钟）"
          height="400px"
        />
      </el-col>
      <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8" class="chart-col">
        <year-bar-chart
          :years="wxPayTop10x"
          :statistics="wxPayTop10y"
          title="微信充值金排名（元）"
          height="400px"
        />
      </el-col>
      <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8" class="chart-col">
        <year-bar-chart
          :years="backendPayTop10x"
          :statistics="backendPayTop10y"
          title="后台充值金排名（元）"
          height="400px"
        />
      </el-col>
    </el-row>
  </div>
</template>

<script>
import YearBarChart from '@/components/chartComponents/YearBarChart.vue'
import YearRangePicker from '@/components/YearRangePicker.vue'
import TopNav from '../Components/topNav.vue'

export default {
  components: {
    TopNav,
    YearBarChart,
    YearRangePicker
  },
  data() {
    return {
      yearList: [],
      startYear:2021,
      endYear:2025,
      newHostedApps: [],
      newAuthCodes: [],
      newUsers: [],
      summaryParmasInfo: {},
      appliUseYearDataList: [],
      snUseYearDataList: [],
      weixinAmountDataList: [],
      backAmountDataList:[],
      appliUseTop10x:[],
      appliUseTop10y:[],
      snUseTop10x:[],
      snUseTop10y:[],
      natUseTop10x:[],
      natUseTop10y:[],
      wxPayTop10x:[],
      wxPayTop10y:[],
      backendPayTop10x:[],
      backendPayTop10y:[],
    }
  },
  watch: {
    'summaryParmasInfo': {
      handler(val) {
        this.getAnalysis();
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    handleYearChange(years) {
      this.startYear = years[0]
      this.endYear = years[years.length - 1];
      this.getAnalysis();
    },
    receiveParamsInfo(val) {
      this.summaryParmasInfo = val;
    },
    getAnalysis() {
      this.resetData();
      let params = {
        startYear: this.startYear,
        endYear: this.endYear
      }
      this.getRequest('/dev/system/dvw/operation/addData', params).then(res => {
        if(res.status===200 && res.data.code ===1000) {
          this.yearList = res.data.result.appliYearDataList.map(item => item.year );
          this.newHostedApps = res.data.result.appliYearDataList.map(item => item.data );
          this.newAuthCodes = res.data.result.snYearDataList.map(item => item.data );
          this.newUsers = res.data.result.userYearDataList.map(item => item.data );
        }
      })
      this.getRequest('/dev/system/dvw/operation/useData', params).then(res => {
        if(res.status===200 && res.data.code ===1000) {
          this.appliUseYearDataList = res.data.result.appliUseYearDataList.map(item => item.data );
          this.snUseYearDataList = res.data.result.snUseYearDataList.map(item => item.data );
          this.weixinAmountDataList = res.data.result.weixinAmountDataList.map(item => item.data );
          this.backAmountDataList = res.data.result.backAmountDataList.map(item => item.data );
        }
      })
      this.getRequest('/dev/system/dvw/operation/top10Data', params).then(res => {
        if(res.status===200 && res.data.code ===1000) {
          this.appliUseTop10x = res.data.result.appliUseTop10.map(item => item.accountId );
          this.appliUseTop10y = res.data.result.appliUseTop10.map(item => item.data );
          this.snUseTop10x = res.data.result.snUseTop10.map(item => item.accountId );
          this.snUseTop10y = res.data.result.snUseTop10.map(item => item.data );
          this.natUseTop10x = res.data.result.natUseTop10.map(item => item.accountId );
          this.natUseTop10y = res.data.result.natUseTop10.map(item => item.data );
          this.wxPayTop10x = res.data.result.wxPayTop10.map(item => item.accountId );
          this.wxPayTop10y = res.data.result.wxPayTop10.map(item => item.data );
          this.backendPayTop10x = res.data.result.backendPayTop10.map(item => item.accountId );
          this.backendPayTop10y = res.data.result.backendPayTop10.map(item => item.data );
        }
      })
    },
    resetData() {
      this.newHostedApps = [];
      this.newAuthCodes = [];
      this.newUsers = [];
      this.backAmountDataList = [];
      this.appliUseYearDataList = [];
      this.snUseYearDataList = [];
      this.weixinAmountDataList = [];

    }
  }
}
</script>

<style lang='scss' scoped>
.developer {
  .choose-date {
    height: 39px;
    margin-top: 30px;
    margin-bottom: 15px;
    border-bottom: 1px solid #333;
    padding-bottom: 10px;
  }
  .summary-row {
    margin: 20px 0;
    .chart-col {
      margin-bottom: 20px;
      @media screen and (max-width: 768px) {
        margin-bottom: 30px;
      }
    }
  }
}
</style>
